import Header from './header';
import Navbar from './navbar';
import styles from './layout.module.scss';
import HomeContent from './home-content';
import WebsiteContent from './website-content';
import ReactFullpage from '@fullpage/react-fullpage';
import { useEffect, useState } from 'react';
import MobileContent from './mobile-content';
import MobileSlide from './mobi-slide';
import { LeftArrowCircle, RightArrowCircle } from '../image';
import account from '../apis/account';
import app from '../apis/app';

export default function Layout() {
  const [origin, setOrigin] = useState({ index: 0 });
  const [viewDirection, setViewDirection] = useState('');
  const [fullpageApi, setFullpageApi] = useState({});
  const [destination, setDestination] = useState({ index: 0 });
  const [showNavigation, setShowNavigation] = useState(false);
  const [appData, setAppData] = useState([]);
  const [appdisplay, setAppDisplay] = useState(0);
  const onLeavePage = (origin, destination, direction) => {
    setViewDirection(direction);
    setOrigin(origin);
    setDestination(destination);
    const section = document.querySelectorAll('.section');
    // console.log(fullpageApi);
    section[origin.index].classList.add('hidden');
    section[destination.index].classList.remove('hidden');
    if (origin.index === 2) {
      setTimeout(() => setShowNavigation(false), 1000);
    }
  };

  const loadAOS = (_, { index }) => {
    if (index === 0) {
      return;
    } else {
      try {
        document
          .querySelectorAll('.fp-table.active .aos-init')
          .forEach((element) => {
            element.classList.add('aos-animate');
          });
      } catch (e) {
        console.log(e);
      }
    }
    if (destination.index === 2) {
      console.log(fullpageApi.getActiveSlide());
      const { index } = fullpageApi.getActiveSlide();
      if (index == 1) {
        fullpageApi.moveSlideLeft();
      }
    }
  };
  const onSlide = (e) => {
    document
      .querySelector(`.${styles['active']}`)
      .classList.remove(styles['active']);
    e.currentTarget.classList.add(styles['active']);
  };

  useEffect(async () => {
    if (!sessionStorage.connected) {
      await account.count();
      sessionStorage.connected = true;
    }
  }, []);

  useEffect(() => {
    app.getContent().then((res) => {
      setAppData(res.data);
    });
  }, []);
  return (
    <div className={styles['layout']}>
      <div className={styles['header-layout']}>
        <Header />
      </div>
      <div className={styles['nav-layout']}>
        <Navbar
          origin={origin}
          viewDirection={viewDirection}
          fullpageApi={fullpageApi}
          destination={destination}
        />
      </div>
      <div className={styles['content-layout']}>
        <ReactFullpage
          //fullpage options
          onLeave={onLeavePage}
          scrollingSpeed={1000} /* Options here */
          afterLoad={loadAOS}
          resetSliders={true}
          render={({ state, fullpageApi }) => {
            setFullpageApi(fullpageApi);
            return (
              <ReactFullpage.Wrapper>
                <div className="section">
                  {/* <div className={styles['header-space']}></div> */}
                  <HomeContent fullpageApi={fullpageApi} />
                </div>
                <div className="section hidden">
                  <div className={styles['header-space']}></div>
                  <WebsiteContent fullpageApi={fullpageApi} />
                </div>
                <div className="section hidden">
                  <div className={styles['header-space']}></div>
                  <div className="slide" data-anchor="slide1">
                    <MobileContent
                      setShowNavigation={setShowNavigation}
                      showNavigation={showNavigation}
                      content={appData[appdisplay]}
                      slide={appData.map((e) => {
                        return e.imgSlide;
                      })}
                      display={setAppDisplay}
                    />
                  </div>
                  <div className="slide" data-anchor="slide2">
                    <MobileSlide content={appData[appdisplay]} />
                  </div>
                  <div>
                    <div
                      className={styles['arrow-group']}
                      style={showNavigation ? { right: '60px' } : {}}
                    >
                      <span onClick={() => fullpageApi.moveTo(3, 0)}>
                        <RightArrowCircle />
                      </span>
                      <span onClick={() => fullpageApi.moveTo(3, 1)}>
                        <LeftArrowCircle />
                      </span>
                    </div>
                    <div
                      className={styles['navigation_bottom']}
                      style={showNavigation ? { right: '60px' } : {}}
                    >
                      01&nbsp;&nbsp;
                      <div
                        className={`${styles['item']} ${styles['active']}`}
                        onClick={(e) => {
                          onSlide(e);
                          fullpageApi.moveTo(3, 0);
                        }}
                      ></div>
                      <div
                        className={styles['item']}
                        onClick={(e) => {
                          onSlide(e);
                          fullpageApi.moveTo(3, 1);
                        }}
                      ></div>
                      &nbsp;&nbsp;02
                    </div>
                  </div>
                </div>
              </ReactFullpage.Wrapper>
            );
          }}
        />
      </div>
    </div>
  );
}
